import { StringHelper } from "../../../../utilities/contracts/string-helper";
import { ChartLakeInputData } from "./chart-lake-input-data.model";
import { ChartLakeLoadData } from "./chart-lake-load-data.model";

export class ChartLakeMatchLoadDetails {
  loadId?: number;
  userId?: number;
  organizationId?: number;
  projectId?: number;
  projectName?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  inputData?: ChartLakeInputData;
  loadData?: ChartLakeLoadData[];
  totalChasesInProject?: number;
  totalChasesAvailableForMatch?: number;
  totalChasesWithMatchesFound?: number;
  totalChildRecords?: number;

  constructor(options: Partial<ChartLakeMatchLoadDetails> = {}) {
    this.loadId = options.loadId;
    this.userId = options.userId;
    this.organizationId = options.organizationId;
    this.projectId = options.projectId;
    this.projectName = StringHelper.clean(options.projectName);
    this.status = StringHelper.clean(options.status);
    this.startDate = StringHelper.clean(options.startDate);
    this.endDate = StringHelper.clean(options.endDate);
    this.inputData = new ChartLakeInputData(options.inputData || {});
    this.loadData = (options.loadData || []).map(d => new ChartLakeLoadData(d));
    this.totalChasesInProject = options.totalChasesInProject;
    this.totalChasesAvailableForMatch = options.totalChasesAvailableForMatch;
    this.totalChasesWithMatchesFound = options.totalChasesWithMatchesFound;
    this.totalChildRecords = options.totalChildRecords;
  }
}
